import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/Home";
import { cleanAuthParams } from "./services/authService";

function App() {
  const auth = useAuth();

  // Automatically redirect to Cognito sign-in if not authenticated after loading
  useEffect(() => {
    // Only redirect if explicitly not authenticated (not during initial loading)
    if (
      !auth.isLoading &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.error
    ) {
      auth.signinRedirect();
    }
  }, [
    auth.isLoading,
    auth.isAuthenticated,
    auth.activeNavigator,
    auth.error,
    auth,
  ]);

  // Clean URL parameters after successful authentication
  useEffect(() => {
    if (auth.isAuthenticated) {
      cleanAuthParams();
    }
  }, [auth.isAuthenticated]);

  if (auth.isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="h-screen flex items-center justify-center text-center">
        <div>
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <h1 className="text-xl font-bold mb-2">Authentication Error</h1>
          <p className="text-gray-600 mb-4">{auth.error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-primary/90"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  // While redirecting, show a message (this should be short-lived)
  if (!auth.isAuthenticated) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-pulse text-4xl mb-4">🔄</div>
          <p className="text-gray-600">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  // Render your authenticated routes
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <HomePage />
          </Layout>
        }
      />
      {/* Catch-all: redirect unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
